import BookingProjectSettings from '../types/model/BookingProjectSettings';
import ProjectService from '../services/ProjectsService';
import AbstractRestRepository from './AbstractRestRepository';

export default class ProjectSettingsRepository extends AbstractRestRepository<BookingProjectSettings> {
  async get(projectId: number): Promise<BookingProjectSettings | null> {
    const response = await ProjectService.getSettings(projectId);
    const settings = this.unpackResponseContent(response);
    return { ...settings, id: projectId };
  }
}
